import { INotifyDetached, IValidatable } from "../../../UI.BaseControls/ControlInterfaces";
/**
     * Data buňky datagridu
     */
export interface ICellContent extends INotifyDetached {
    /**
     * Kořenový element zobrazený v buňce
     */
    visualElement: HTMLElement;
    /**
     * Element, kterému se nastavují a aktualizují data určená k zobrazení
     */
    dataElement: HTMLElement;
    /**
     * Element, který se zobrazuje jako zašifrovaná hodnota
     */
    encryptionElement?: HTMLElement;
    /**
     * Prvek určený k validaci
     */
    validatableControl: IValidatable;
}
